// Boot Tablier : ouvre la base (data layer B-001), log le tenantId courant,
// puis monte l'app React. Le boot data layer existant est CONSERVÉ tel quel.
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { getDb } from './db';
import { getCurrentTenantId } from './db/tenant';
import { seedCatalogue } from './db/transactions';
import { CATALOGUE, SEED_VERSION } from './config/catalogue.pizznco';
import { App } from './app/App';
import './app/index.css';

void (async () => {
  const tenantId = getCurrentTenantId();
  const db = getDb();
  await db.open();
  // Seed catalogue idempotent (D3) — no-op si marqueur ≥ SEED_VERSION.
  await seedCatalogue(CATALOGUE, SEED_VERSION);
  console.warn('[tablier] data layer booted', {
    tenantId,
    dbName: db.name,
    version: db.verno,
  });
})();

const rootEl = document.getElementById('app');
if (rootEl) {
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
